import React from "react";

export function LinkIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-icon="link"
      {...props}
    >
      <path
        d="M6.0415 7.8685C6.72328 9.60734 8.80576 9.90031 10.0312 8.65405C11.0078 7.66206 12.0717 6.74596 13.0717 5.77294C14.0976 4.77411 13.9094 3.23564 12.6985 2.48652C11.8277 1.94764 10.6669 2.04859 9.87124 2.74534C9.53682 3.03831 9.23066 3.35936 8.89301 3.64929C8.80415 3.72519 8.62805 3.79046 8.52546 3.76011C7.6797 3.50888 6.82102 3.41173 5.86864 3.53696C5.97123 3.42236 6.02858 3.34873 6.09643 3.28422C6.7984 2.62087 7.4931 1.95144 8.20638 1.29947C9.53762 0.0797771 11.1209 -0.299717 12.8811 0.239164C14.6154 0.769696 15.6502 1.95144 15.9369 3.63715C16.1664 4.98283 15.7681 6.2048 14.7519 7.19528C13.6137 8.30492 12.4675 9.41152 11.2647 10.4582C9.31306 12.1568 6.12632 11.8327 4.60525 9.83731C4.39927 9.56787 4.36453 9.39255 4.65857 9.14891C5.1287 8.76031 5.55441 8.32314 6.03989 7.86774L6.0415 7.8685Z"
        fill={props.fill}
      />
      <path
        d="M9.37439 12.5408C8.42521 13.4425 7.55014 14.4471 6.50814 15.221C5.19142 16.1991 3.68082 16.2324 2.22935 15.454C0.824299 14.699 0.0757361 13.4811 0.00462259 11.857C-0.0507711 10.5989 0.393127 9.53989 1.25847 8.65405C2.2054 7.68577 3.15682 6.72202 4.11648 5.76659C5.76107 4.12958 8.12953 4.00173 9.88041 5.44433C9.91934 5.4761 9.95752 5.50863 9.9942 5.54192C10.8753 6.33395 10.8805 6.4459 10.0691 7.26517C9.79807 7.53825 9.5256 7.81058 9.22692 8.11015C9.16703 7.99062 9.13335 7.92859 9.1049 7.86505C8.51204 6.52079 6.87493 6.10246 5.80673 7.09269C4.68614 8.13133 3.61569 9.22897 2.57893 10.3531C1.82438 11.1708 1.9434 12.4848 2.74736 13.2557C3.53859 14.0144 4.79243 14.0356 5.60313 13.2905C5.93474 12.9856 6.23641 12.6467 6.56428 12.3366C6.64213 12.2624 6.78885 12.1762 6.8682 12.2027C7.66841 12.4712 8.48509 12.5575 9.37513 12.5393L9.37439 12.5408Z"
        fill={props.fill}
      />
    </svg>
  );
}
